import { HeaderLoadingSkeleton } from '../components/shared/Header/HeaderLoadingSkeleton';
import styles from './LandingDestinationLoading.module.scss';

export const LandingDestinationLoading = () => {
  return (
    <div className={styles.loadingShell}>
      <HeaderLoadingSkeleton />
    </div>
  );
};
